import { render } from "./ProductQuantityAlertPage.vue?vue&type=template&id=0c8a7da8&scoped=true&ts=true"
import script from "./ProductQuantityAlertPage.vue?vue&type=script&lang=ts"
export * from "./ProductQuantityAlertPage.vue?vue&type=script&lang=ts"

import "./ProductQuantityAlertPage.vue?vue&type=style&index=0&id=0c8a7da8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c8a7da8"]])

export default __exports__